document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-collection-section]')
  if (!section) return

  const lineInners = section.querySelectorAll('[data-collection-line]')
  const productsBlock = section.querySelector('[data-collection-products]')
  const productImages = productsBlock?.querySelectorAll('[data-collection-grid] img')
  const categoriesNav = section.querySelector('[data-collection-categories]')
  const categoryLinks = categoriesNav ? [...categoriesNav.querySelectorAll('a')] : []
  const filterToggle = section.querySelector('[data-collection-filter]')
  const isDesktop = window.matchMedia('(min-width: 1200px)').matches

  gsap.set(lineInners, { yPercent: 120, opacity: 0 })

  if (categoryLinks.length) {
    gsap.set(categoryLinks, isDesktop ? { y: 16, opacity: 0 } : { x: 28, opacity: 0 })
    categoryLinks.forEach((link) => {
      link.classList.remove('opacity-0')
      link.style.transition = 'none'
    })
  }

  if (filterToggle) gsap.set(filterToggle, { y: isDesktop ? 16 : 40, opacity: 0 })

  if (productsBlock) {
    gsap.set(productsBlock, { y: 40, autoAlpha: 0 })
    if (productImages?.length) gsap.set(productImages, { scale: 1.08 })
  }

  const reveal = () => {
    const tl = gsap.timeline()

    tl.to(lineInners, {
      yPercent: 0,
      opacity: 1,
      duration: 0.9,
      ease: 'power3.out',
      stagger: 0.12,
    })

    if (categoryLinks.length) {
      tl.to(
        categoryLinks,
        {
          ...(isDesktop ? { y: 0 } : { x: 0 }),
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: isDesktop ? 0 : 0.1,
          clearProps: 'opacity,transform',
          onComplete: () => {
            categoryLinks.forEach((link) => {
              link.style.transition = ''
            })
          },
        },
        '-=0.45',
      )
    }

    if (filterToggle) {
      tl.to(
        filterToggle,
        {
          y: 0,
          opacity: 1,
          duration: isDesktop ? 0.8 : 1.3,
          ease: 'power3.out',
          clearProps: 'transform',
        },
        categoryLinks.length ? '<' : '-=0.45',
      )
    }

    if (productsBlock) {
      tl.to(
        productsBlock,
        {
          y: 0,
          autoAlpha: 1,
          duration: 1.3,
          ease: 'power3.out',
        },
        categoryLinks.length || filterToggle ? '<' : '-=0.4',
      )

      if (productImages?.length) {
        tl.to(
          productImages,
          {
            scale: 1,
            duration: 1.3,
            ease: 'power3.out',
          },
          '<',
        )
      }
    }
  }

  const reset = () => {
    gsap.set(lineInners, { yPercent: 120, opacity: 0 })
    if (categoryLinks.length) {
      gsap.set(categoryLinks, isDesktop ? { y: 16, opacity: 0 } : { x: 28, opacity: 0 })
      categoryLinks.forEach((link) => { link.style.transition = 'none' })
    }
    if (filterToggle) gsap.set(filterToggle, { y: isDesktop ? 16 : 40, opacity: 0 })
    if (productsBlock) {
      gsap.set(productsBlock, { y: 40, autoAlpha: 0 })
      if (productImages?.length) gsap.set(productImages, { scale: 1.08 })
    }
  }

  if (window.ScrollTrigger) {
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top 75%',
      onEnter: reveal,
    })
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      onLeaveBack: reset,
    })
  } else {
    reveal()
  }
})
